import request from '@/assets/js/request';

/**
 * @description 获取表演语言
 * @export
 * @returns
 */
export function getLangCode() {
    return new Promise((resolve, reject) => {
        request({
            url: '/common/view/displayLang.json',
            method: 'post',
            data: {type: 5},
        })
            .then((res) => {
                if (!res.data.state) {
                    throw new Error(res.data.msg);
                }
                // format
                const langCode = [];
                res.data.result.forEach((item) => {
                    langCode.push({id: item.code, name: item.name});
                });
                resolve(langCode);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * @description 获取风格流派 二级分类-4级tag
 * @export
 * @returns
 */
export function getGenre() {
    return new Promise((resolve, reject) => {
        request({
            url: '/common/view/findGenre.json',
            method: 'post',
        })
            .then((res) => {
                if (!res.data.state) {
                    throw new Error(res.data.msg);
                }
                // format
                const genre = [];
                res.data.result.forEach((item) => {
                    const p = {value: item.id, label: item.categoryName, children: []};
                    item.childTags.forEach((citem) => {
                        p['children'].push({value: citem.id, label: citem.name});
                    });
                    genre.push(p);
                });
                resolve(genre);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * @description 获取艺人 BY 名称
 * @param {*} name
 * @param {*} isNeedDefault
 * @param {*} displayLangCode
 */
export function fetchArtistByName(name, isNeedDefault = 0, displayLangCode) {
    return request({
        url: '/artist/view/name.json',
        method: 'get',
        params: {
            name: name,
            isNeedDefault: isNeedDefault,
            displayLangCode: displayLangCode,
        },
    });
}

/**
 * @description 获取艺人类型选项
 */
export function fetchArtistType() {
    return request({
        url: '/common/view/artist_type.json',
        method: 'get',
    });
}
/**
 * @description 获取省份
 */
export function fetchProvince() {
    return request({
        url: '/common/view/province',
        method: 'get',
    });
}

/**
 * @description 获取城市
 * @param {*} provinceCode 省份code
 */
export function fetchCityList(provinceId) {
    return request({
        url: '/common/view/city',
        method: 'get',
        params: {provinceId: provinceId},
    });
}
/**
 * @description 机检接口
 * @param {integer} cpId cpId
 * @param {integer} verifyType 校验类型， 100. CP是否开启APPLE标准校验, 200. WAV文件RIFF头校验
 * @param {string} verifyValue 校验值
 * @requires ifAppleVerify 是否开启AppleMusic曲库校验标准校验，1.是，0.否
 * @requires valid 是否有效， 1.有效， 0.无效
 */
export function checkAppleVerifyInfo(params) {
    return request({
        url: '/machine/check/checkAppleVerifyInfo',
        method: 'post',
        data: params,
        formData: false,
    });
}
